import { z } from 'zod';
import { requiredString } from '@/shared/lib/validation';

/** Проверяет введённые координаты дома */
export const houseCoordinatesSchema = z.object({
    latitude: requiredString('Укажите широту')
        .transform((value) => Number(value.replace(',', '.')))
        .pipe(z.number()
            .min(-90, 'Широта от -90 до 90')
            .max(90, 'Широта от -90 до 90')),
    longitude: requiredString('Укажите долготу')
        .transform((value) => Number(value.replace(',', '.')))
        .pipe(z.number()
            .min(-180, 'Долгота от -180 до 180')
            .max(180, 'Долгота от -180 до 180')),
});

/** Проверяет поля ручной проверки координат */
export const addressPointFormSchema = houseCoordinatesSchema.extend({
    coordinatePair: z.string(),
});

export type AddressPointFormValues = z.input<typeof addressPointFormSchema>;

export type VerifiedAddressPointValues = z.output<typeof addressPointFormSchema>;
